import { History } from "@mui/icons-material";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { accessTokenKey } from "misc/authProvider";
import { apiHost } from "misc/settings";
import { useEffect, useState } from "react";
import { useLogin, useTranslate } from "react-admin";

const LoginPage = () => {
  const login = useLogin();
  const translate = useTranslate();
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const { searchParams } = new URL(window.location.href);
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (code && state) {
      login({ code, state }).catch(() => setShowError(true));
    } else if (!localStorage.getItem(accessTokenKey)) {
      login({}).catch(() => setShowError(true));
    }
  }, []);

  if (showError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "600px",
          textAlign: "center",
          marginLeft: "auto",
          marginRight: "auto",
          paddingTop: "20vh",
          minHeight: "100vh",
        }}
      >
        <Typography component="h2" variant="h5" mb={4}>
          {translate("login_error")}
        </Typography>
        <Typography variant="body1" mb={4}>
          {translate("login_error_message")}
        </Typography>
        <div>
          <Button
            variant="contained"
            color="primary"
            startIcon={<History />}
            onClick={() => (window.location.href = apiHost)}
          >
            {translate("try_again")}
          </Button>
        </div>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", paddingTop: "40vh", minHeight: "100vh" }}>
      <CircularProgress />
    </Box>
  );
};

export default LoginPage;
